import React from 'react';
import { connect } from 'react-redux';
import {
  updateProps as updatePropsAction,
  getTemplatesForGroupWizard as getTemplatesForGroupWizardAction,
  createTemplateGroup as createTemplateGroupAction,
} from '../../../../stores/contracting/template-list/template-list-actions';
import RaisedButton from '../../../tc-ui/raised-button-with-loader';
import supplierWizardCompleteImage from '../../../../../www/images/supplier-wizard-complete.svg';
import StepTwoTemplates from './step-two-templates';
import moment from 'moment';
import R from 'ramda';
import pluralize from 'pluralize';
import debounce from 'lodash.debounce';
import { Step, StepLabel, Stepper, StepContent, FlatButton, StepButton, Dialog } from 'material-ui';
import StepOneNameNdates from './step-one-name-dates';
const convertToYY = ({ startDate, endDate }) => `${moment.utc(startDate).format('MMM DD YYYY')} - ${moment.utc(endDate).format('MMM DD YYYY')}`;


class GroupWizard extends React.Component {
  componentWillUnmount() {
    this.props.clearGroupWizard();
  }
  selectContractYear = ({ startDate, endDate }) => {
    const { updateProps, getTemplatesForGroupWizard } = this.props;
    updateProps({ newGroupStartDate: startDate, newGroupEndDate: endDate });
    getTemplatesForGroupWizard({ startDate, endDate });
  };
  goToStepTwo = () => {
    const { updateProps, newGroupName, newGroupStartDate, newGroupEndDate } = this.props;
    const dataValid = R.call(R.allPass([
      () => newGroupStartDate,
      () => newGroupEndDate,
      () => newGroupName,
    ]));
    if (dataValid) updateProps({ groupWizardStep: 1 });
    else {
      updateProps({ createGroupError: 'Please fill out all required fields.' });
      debounce(() => updateProps({ createGroupError: '' }), 4000)();
    }
  };
  createTemplateGroup = () => {
    const { selectedTemplatesForGroup, updateProps, createTemplateGroup, newGroupName, newGroupStartDate, newGroupEndDate } = this.props;
    if (selectedTemplatesForGroup.length) {
      createTemplateGroup({ templates: selectedTemplatesForGroup, newGroupName, startDate: newGroupStartDate, endDate: newGroupEndDate });
    } else {
      updateProps({ createGroupError: 'Please select templates.' });
      debounce(() => updateProps({ createGroupError: '' }), 4000)();
    }
  };
  render() {
    const {
      groupWizardStep,
      createGroupError,
      groupWizardTemplates,
      updateTemplateProps,
      templateGroups,
      updateProps,
      newGroupName,
      newGroupStartDate,
      newGroupEndDate,
      allContractPeriods,
      selectedTemplatesForGroup,
      loadingForGroupWizard,
      groupCreated,
      afterCreationFn,
    } = this.props;
    const selectedLength = selectedTemplatesForGroup.length;
    if (groupCreated) {
      return (
        <div style={{ textAlign: 'center' }}>
          <img
            src={supplierWizardCompleteImage}
            style={{ width: '25%', display: 'block', margin: 'auto' }}
          />
          <h4>Congratulations! You have successfully created a template group!</h4>
          <RaisedButton label="View Template Groups" secondary onTouchTap={afterCreationFn}
          />
        </div>
      );
    }
    return (
      <div>
        <small style={{ margin: '12px 20px 0', display: 'block' }}>
          Template Groups are similar to folders, and are only used to allow you to send multiple templates to your partners at once, similar to a bulk send.
        </small>
        <Stepper activeStep={groupWizardStep} orientation="vertical">
          <Step>
            <StepLabel>
              {groupWizardStep === 0 ? 'Name & Dates'
                : (
                  <StepButton onTouchTap={() => updateProps({ groupWizardStep: 0 })}>
                    {`Group Name: ${newGroupName} (${convertToYY({ startDate: newGroupStartDate, endDate: newGroupEndDate })})`}
                  </StepButton>)
              }
            </StepLabel>
            <StepContent>
              <StepOneNameNdates
                newGroupName={newGroupName}
                allContractPeriods={allContractPeriods}
                selectContractYear={this.selectContractYear}
                updateProps={updateProps}
                newGroupStartDate={newGroupStartDate}
                newGroupEndDate={newGroupEndDate}
              />
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <RaisedButton
                  label="next"
                  secondary
                  onTouchTap={this.goToStepTwo}
                />
                <div style={{ marginLeft: '32px', color: 'red' }}>{createGroupError}</div>
              </div>
            </StepContent>
          </Step>
          <Step>
            <StepLabel>
              Select Templates
              {selectedLength ? ` (${selectedLength} ${pluralize('template', selectedLength)} selected)` : ''}
            </StepLabel>
            <StepContent>
              <StepTwoTemplates
                templates={groupWizardTemplates}
                updateProps={updateProps}
                selectedTemplatesForGroup={selectedTemplatesForGroup}
                loadingForGroupWizard={loadingForGroupWizard}
              />
              <div style={{ display: 'flex', marginTop: '24px', alignItems: 'center' }}>
                <FlatButton
                  label="Back"
                  onTouchTap={() => updateProps({ groupWizardStep: 0 })}
                />
                <RaisedButton
                  label={ groupWizardStep ? 'Create Group' : 'Next' }
                  style={{ marginLeft: '8px' }}
                  secondary
                  onTouchTap={this.createTemplateGroup}
                />
                <div style={{ marginLeft: '32px', color: 'red' }}>{createGroupError}</div>
              </div>
            </StepContent>
          </Step>
        </Stepper>
      </div>
    );
  }
};

const mapDispatchToProps = dispatch => ({
  updateProps: payload => dispatch(updatePropsAction(payload)),
  getTemplatesForGroupWizard: (...args) => dispatch(getTemplatesForGroupWizardAction(...args)),
  createTemplateGroup: (...args) => dispatch(createTemplateGroupAction(...args)),
  clearGroupWizard: () => dispatch({ type: 'TEMPLATE_GROUP_CREATION_UNMOUNT' }),
});
const mapStateToProps = ({ contracting }) => ({
  ...contracting.templateList.toJS(),
  allContractPeriods: contracting.contractPeriods,
});
GroupWizard.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(GroupWizard);



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/create-group/create-group-wizard.jsx